import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=541ca1b8&scoped=true&"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectDashboard.vue?vue&type=style&index=1&id=541ca1b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ca1b8",
  null
  
)

export default component.exports